export default __webpack_public_path__ + "static/media/class_repeat.a8e8a295.svg";